export function URL2GET() {
    let preParams = document.location.search.substr(1).split('&'),
        params = {},
        oneParam;
    if (preParams.length) {
        preParams.forEach(function (item) {
            oneParam = item.split('=');
            if (oneParam[0] !== undefined && oneParam[0] !== '' && oneParam[1] !== undefined) {
                params[oneParam[0]] = oneParam[1];
            }
        });
    }
    return params;
}

/**
 * @return {string}
 */
export function GET2URL(newParams, deleteParams) {

    let oldParams = URL2GET(),
        params,
        URL = '';
    for (let param in oldParams) {
        if (oldParams.hasOwnProperty(param)) {
            if (param.split('_')[0] === 'param' ||~deleteParams.indexOf(param)) {
                delete oldParams[param];
            }
        }
    }
    params = Object.assign({}, oldParams, newParams);
    for (let param in params) {
        if (params.hasOwnProperty(param) && params[param] !== undefined) {
            URL += '&' + param + '=' + params[param];
        }
    }
    return URL.length  ? '?' + URL.substr(1) : "";
}